import { render, staticRenderFns } from "./ExportSetup.vue?vue&type=template&id=555a2fff&scoped=true"
import script from "./ExportSetup.vue?vue&type=script&lang=js"
export * from "./ExportSetup.vue?vue&type=script&lang=js"
import style0 from "./ExportSetup.vue?vue&type=style&index=0&id=555a2fff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555a2fff",
  null
  
)

export default component.exports